module.exports = __webpack_public_path__ + "static/Hero-voter.aca88af7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Hero-voter.jpg
// module id = 497
// module chunks = 265584890008614